import { render } from "./ChatMessageList.vue?vue&type=template&id=54650bd1&scoped=true"
import script from "./ChatMessageList.vue?vue&type=script&lang=js"
export * from "./ChatMessageList.vue?vue&type=script&lang=js"

import "./ChatMessageList.vue?vue&type=style&index=0&id=54650bd1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-54650bd1"

export default script